import { partnerUrl } from "../Config/Url";
import axios from "axios";

export const partnerService = {
  get,
  update,
  getById,
  create,
  deletePartner,
  validateOib,
  bulkImportValidate,
  bulkImport,
  sendToPartner,
  sendToMail,
};

async function get({
  tenantId,
  searchName,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
}) {
  return axios
    .put(`${partnerUrl}/search`, {
      tenantId,
      searchText: searchName,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function update({
  partnerId,
  tenantId,
  name,
  description,
  taxNumber,
  street,
  streetNumber,
  streetNumberExtension,
  city,
  countryId,
  postalNumber,
  iban,
  email,
  phone,
  discount,
  branch
}) {
  return axios
    .put(`${partnerUrl}/${partnerId}`, {
      tenantId,
      name,
      description,
      taxNumber,
      street,
      streetNumber,
      streetNumberExtension,
      city,
      countryId,
      postalNumber,
      iban,
      email,
      phone,
      discount,
      branch
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function getById(partnerId) {
  return axios
    .get(`${partnerUrl}/${partnerId}`)
    .then((res) => res)
    .catch((err) => err.response.data);
}

async function create({
  tenantId,
  name,
  description,
  taxNumber,
  street,
  streetNumber,
  streetNumberExtension,
  city,
  countryId,
  postalNumber,
  iban,
  email,
  phone,
  discount,
  branch
}) {
  return axios
    .post(partnerUrl, {
      tenantId,
      name,
      description,
      taxNumber,
      street,
      streetNumber,
      streetNumberExtension,
      city,
      countryId,
      postalNumber,
      iban,
      email,
      phone,
      discount,
      branch
    })
    .then((res) => res)
    .catch((err) => {
      console.log("err", err.response);
    });
}

async function deletePartner(partnerId) {
  return axios
    .delete(`${partnerUrl}/${partnerId}`)
    .then((res) => res)
    .catch((err) => err.response);
}

function validateOib(oib) {
  if (oib.length != 11) return false;
  var b = parseInt(oib, 10);
  if (isNaN(b)) return false;
  var a = 10;
  for (var i = 0; i < 10; i++) {
    a = a + parseInt(oib.substr(i, 1), 10);
    a = a % 10;
    if (a == 0) a = 10;
    a *= 2;
    a = a % 11;
  }
  var kontrolni = 11 - a;
  if (kontrolni == 10) kontrolni = 0;

  return kontrolni == oib[10] ? true : false;
}

async function bulkImportValidate({ tenantId, data }) {
  return axios
    .post(`${partnerUrl}/import/validate`, {
      tenantId,
      data,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function bulkImport({ tenantId, data }) {
  return axios
    .post(`${partnerUrl}/import`, {
      tenantId,
      data,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function sendToMail( email, invoicePdf, invoiceGuid ) {
  console.log("send to mail service", email, invoiceGuid);
  return axios
    .post(`${partnerUrl}/send-mail-invoice`, {
      email,
      invoicePdf,
      invoiceGuid,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
async function sendToPartner({ partnerGuid, invoicePdf, invoiceGuid }) {
  return axios
    .post(`${partnerUrl}/send-invoice`, {
      partnerGuid,
      invoicePdf,
      invoiceGuid,
    })
    .then((res) => res)
    .catch((err) => err.response);
}
